import Text from 'components/shared/Text'
import styled from 'styled-components'

export const CustomLink = styled(Text)`
    &:hover {
        color: ${({ theme }) => theme.colors.secondary_700};
    }
`
